function SvgBubble(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 92 77"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.701 61.863a3.246 3.246 0 00-1.229-3.53C10.964 52.96 6.481 44.268 6.481 35.084c0-15.771 12.83-28.602 28.601-28.604h21.832c7.641 0 14.825 2.975 20.226 8.376s8.375 12.582 8.375 20.221c0 15.769-12.831 28.598-28.601 28.598H35.081c-2.109 0-4.274-.25-6.429-.746a3.23 3.23 0 00-3.038.883c-2.644 2.69-6.285 4.398-9.489 5.297 2.096-2.884 3.118-5.659 3.576-7.246m62.023-51.588C75.101 3.649 66.291 0 56.916 0H35.083C15.738 0 0 15.738 0 35.083c0 10.341 4.747 20.378 12.734 27.003a17.226 17.226 0 01-3.545 5.204c-.275.277-.532.493-.754.68l-.079.067c-.861.722-3.149 2.639-1.669 5.92 1.074 2.394 3.923 2.394 4.86 2.394 3.888 0 11.635-1.806 17.366-6.754 2.033.368 4.105.556 6.169.562h21.834c19.345 0 35.082-15.737 35.082-35.081 0-9.369-3.649-18.178-10.274-24.803"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgBubble;
